// Populated in main.js
export const env = {
  apiUrl: process.env.NODE_ENV === "development" ? "http://localhost:8080/api" : `${window.location.origin}/api`,
};
